import React, { useEffect, useState } from "react";
import SubmitButton from "../../../Components/SubmitButton/submitButton";
import ActionButton from "../../../Components/ActionButton/actionButton";
import TranslationService from "../../../Services/translationService";
import { useDispatch, useSelector } from "react-redux";
import uuid from "react-uuid";
import Input from "../../../Components/Inputs/input";
import Textarea from "../../../Components/Inputs/textArea";
import {
	addButtonSpinner,
	removeButtonSpinner,
} from "../../../Store/Actions/spinner";

const spinnerId = uuid();

const PromptForm = ({ setKey, eventKey }) => {
	const fieldMaxLength = 120;

	const dispatch = useDispatch();
	const { language } = useSelector(state => state.language);
	const { settings } = useSelector(state => state.settings);
	const { translations } = useSelector(state => state.translation);
	const [translationService, setTranslationService] = useState(null);
	const [isInvalidSubmit, setIsInvalidSubmit] = useState(false);

	const [values, setValues] = useState({
		loginPrompt: "Username",
		passwordPrompt: "Password",
		loginPlaceholder: "Ex. username",
		passwordPlaceholder: "Ex password",
	});

	useEffect(() => {
		setTranslationService(new TranslationService(translations));
	}, [translations]);

	const onChange = (event, fieldName, maxLength = Infinity) => {
		if (maxLength && maxLength < event.target.value.length) {
			return;
		}
		setValues(values => ({
			...values,
			[fieldName]: event.target.value,
		}));
		setIsInvalidSubmit(false);
	};

	const onSubmit = event => {
		event && event.preventDefault();
		const formData = new FormData();
		dispatch(addButtonSpinner(spinnerId));
		Object.entries(values).forEach(([key, value]) => {
			formData.append(key, value);
		});
		if (settings && settings.id) {
			formData.append("id", settings.id);
		}

		setTimeout(() => {
			dispatch(removeButtonSpinner(spinnerId));
			setKey(eventKey);
		}, 3000);
	};

	return translationService ? (
		<div className="mt-4">
			<form onSubmit={onSubmit}>
				<div className="row mb-3">
					<div className="col-md-6">
						<Input
							type="text"
							id="name"
							name="name"
							value={values.loginPrompt}
							isInvalidSubmit={isInvalidSubmit}
							labelValue="Login prompt"
							fieldLength={fieldMaxLength}
							onChange={event => onChange(event, "loginPrompt", fieldMaxLength)}
						/>
					</div>
					<div className="col-md-6">
						<Input
							type="text"
							id="name"
							name="name"
							value={values.loginPlaceholder}
							isInvalidSubmit={isInvalidSubmit}
							labelValue="Login placeholder"
							fieldLength={fieldMaxLength}
							onChange={event =>
								onChange(event, "loginPlaceholder", fieldMaxLength)
							}
						/>
					</div>
					<div className="col-md-6">
						<Input
							type="text"
							id="name"
							name="name"
							value={values.passwordPrompt}
							isInvalidSubmit={isInvalidSubmit}
							labelValue="Password prompt"
							fieldLength={fieldMaxLength}
							onChange={event =>
								onChange(event, "passwordPrompt", fieldMaxLength)
							}
						/>
					</div>
					<div className="col-md-6">
						<Input
							type="text"
							id="name"
							name="name"
							value={values.passwordPlaceholder}
							isInvalidSubmit={isInvalidSubmit}
							labelValue="Password placeholder"
							fieldLength={fieldMaxLength}
							onChange={event =>
								onChange(event, "passwordPlaceholder", fieldMaxLength)
							}
						/>
					</div>
				</div>

				<ActionButton
					spinnerId={spinnerId}
					type="submit"
					className="mindalay--btn-link mindalay--btn-secondary position-relative mb-3"
					name={translationService.translate("TR_SAVE")}
				/>
			</form>
		</div>
	) : null;
};

export default PromptForm;
